import { useState, useEffect } from 'react'
import { ButtonLinkProps } from '../../core/ButtonLink/ButtonLink'
import ButtonLink from '../../core/ButtonLink/ButtonLink'
import { getUpdatedURL, callTapAPI } from './utils/ButtonLinkWrapperUtils'
import { Button, Spinner } from '@telus-uds/components-web'
import { ErrorDisplay } from '@/siteBuilder/components/errors/ErrorDisplay'
import getConfig from 'next/config'

const {
  publicRuntimeConfig: { API_BASE_PATH },
} = getConfig()

export type ButtonProps = {
  priority?: string
  size?: string
  danger?: boolean
  inverse?: boolean
  width?: string
}

export type ButtonLinkWrapperProps = {
  appendToRParam?: boolean
  insertQueryParam?: string
  insertQueryParamLocation?: string
  encodedQueryParamTarget?: string
  togglePredecode?: boolean
  buttonLinkProps: ButtonLinkProps
  productOfferingId?: string
  buttonText?: string
  buttonProps: ButtonProps
  failureRedirectUrl?: string
}

const ButtonLinkWrapper = ({
  appendToRParam = true,
  insertQueryParam,
  insertQueryParamLocation,
  encodedQueryParamTarget,
  togglePredecode = false,
  buttonLinkProps,
  productOfferingId,
  buttonText,
  buttonProps,
  failureRedirectUrl,
}: ButtonLinkWrapperProps) => {
  const decodedQueryParamTarget = decodeURIComponent(encodedQueryParamTarget)

  const [newUpdatedURL, setNewUpdatedURL] = useState('')
  const [showSpinner, setShowSpinner] = useState(false)
  const [hasApiError, setHasApiError] = useState(false)

  useEffect(() => {
    if (!productOfferingId) {
      let buttonURL = buttonLinkProps.url

      if (togglePredecode) {
        buttonURL = decodeURIComponent(buttonLinkProps.url)
      }

      let updatedURL = getUpdatedURL(
        buttonURL,
        insertQueryParam,
        decodedQueryParamTarget,
        appendToRParam,
        insertQueryParamLocation
      )

      // if url is pre-decoded, re-encodes section of url. eg. after #eli-modal?
      if (updatedURL && updatedURL.startsWith('#') && togglePredecode) {
        const undecodedURLSection = updatedURL.match(/^#.*?=/g)

        if (undecodedURLSection) {
          updatedURL = `${undecodedURLSection[0]}${encodeURIComponent(updatedURL.replace(undecodedURLSection[0], ''))}`
        }
      }

      setNewUpdatedURL(updatedURL)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [buttonLinkProps.url])

  if (hasApiError) {
    if (failureRedirectUrl) {
      window.location.replace(failureRedirectUrl)
    } else {
      return <ErrorDisplay />
    }
  }

  return productOfferingId ? (
    <Spinner size="small" show={showSpinner}>
      <Button
        data-testid={'button-link-wrapper-testid'}
        onPress={async () => {
          await callTapAPI(buttonLinkProps.url, productOfferingId, setShowSpinner, setHasApiError)
        }}
        variant={{ ...buttonProps }}
      >
        {buttonText}
      </Button>
    </Spinner>
  ) : (
    <ButtonLink data-testid={'button-link-wrapper-testid'} {...buttonLinkProps} url={newUpdatedURL}></ButtonLink>
  )
}

export default ButtonLinkWrapper
